var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Differentiators/Calendar/Active/24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Differentiators/Calendar/Active/24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(2.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,1.66666667 L18,1.66666667 C19.1045695,1.66666667 20,2.56209717 20,3.66666667 L20,5.41758242 L0,5.41758242 L0,3.66666667 C-1.3527075e-16,2.56209717 0.8954305,1.66666667 2,1.66666667 Z",
    id: "Rectangle",
    fill: "#DB3725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.476190476,5.23809524 L19.5238095,5.23809524 L19.5238095,14.5714286 C19.5238095,16.7805676 17.7329485,18.5714286 15.5238095,18.5714286 L4.47619048,18.5714286 C2.26705148,18.5714286 0.476190476,16.7805676 0.476190476,14.5714286 L0.476190476,5.23809524 Z",
    id: "Rectangle",
    stroke: "#001823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1428571,0 L17.1428571,0 C17.4058499,-4.83109822e-17 17.6190476,0.213197738 17.6190476,0.476190476 L17.6190476,3.80952381 L16.6666667,3.80952381 L16.6666667,0.476190476 C16.6666667,0.213197738 16.8798644,4.83109822e-17 17.1428571,0 Z",
    id: "Rectangle-Copy",
    fill: "#DB3725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85714286,0 L2.85714286,0 C3.1201356,-4.83109822e-17 3.33333333,0.213197738 3.33333333,0.476190476 L3.33333333,3.80952381 L2.38095238,3.80952381 L2.38095238,0.476190476 C2.38095238,0.213197738 2.59415012,4.83109822e-17 2.85714286,0 Z",
    id: "Rectangle-Copy-2",
    fill: "#DB3725"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.6acd81ea0604ab400834c4106c6766af.svg";
export { ForwardRef as ReactComponent };